import { Box, FormControl, InputLabel, Select } from '@mui/material';
import { SelectProps } from '@mui/material/Select';
import React from 'react';
import { InputActionProps, InputAdditions, InputCollapsibleProps } from './InputAdditions';
import TooltipHardened from '../TooltipHardened';
interface Props {
  children: React.ReactNode;
  label?: string;
  forwardedRef?: React.ForwardedRef<HTMLDivElement>;
  /** Adds a styled button element */
  action?: InputActionProps;
  /** Adds a collapsible area underneath */
  collapsible?: InputCollapsibleProps;
  tooltip?: React.ReactNode;
}

const StyledSelectFieldComponent = ({
  label,
  forwardedRef,
  children,
  action,
  collapsible,
  tooltip,
  ...props
}: Props & SelectProps) => (
  <Box component={'div'} width={'100%'} ref={forwardedRef}>
    <InputAdditions action={action} collapsible={collapsible}>
      <TooltipHardened tooltip={tooltip}>
        <Box component={'div'}>
          <FormControl fullWidth>
            {label !== '' && <InputLabel id={'styled-select-label'}>{label}</InputLabel>}
            <Select {...props} fullWidth label={label} labelId={'styled-select-label'} id={'styled-select'}>
              {children}
            </Select>
          </FormControl>
        </Box>
      </TooltipHardened>
    </InputAdditions>
  </Box>
);

export const StyledSelectField = React.forwardRef<HTMLDivElement, Props & SelectProps>((props, ref) => (
  <StyledSelectFieldComponent {...props} forwardedRef={ref} />
));
